import { render, staticRenderFns } from "./_base-data-table.vue?vue&type=template&id=e3be0c22&scoped=true"
import script from "./_base-data-table.vue?vue&type=script&lang=js"
export * from "./_base-data-table.vue?vue&type=script&lang=js"
import style0 from "./_base-data-table.vue?vue&type=style&index=0&id=e3be0c22&prod&lang=scss&scoped=true"
import style1 from "./_base-data-table.vue?vue&type=style&index=1&id=e3be0c22&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style1.locals || style1)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "e3be0c22",
  null
  
)

export default component.exports